import { render, staticRenderFns } from "./magiczoom.vue?vue&type=template&id=de6c7582&"
import script from "./magiczoom.vue?vue&type=script&lang=js&"
export * from "./magiczoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/22413/203/Snaply5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de6c7582')) {
      api.createRecord('de6c7582', component.options)
    } else {
      api.reload('de6c7582', component.options)
    }
    module.hot.accept("./magiczoom.vue?vue&type=template&id=de6c7582&", function () {
      api.rerender('de6c7582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/snaply/magiczoom.vue"
export default component.exports